// @index(['./*.{ts,tsx}', './*/index.{ts,tsx}'], f => `export {default as ${f.name}} from '${f.path.replace(/\/index$/, '')}'`)
export { default as CashIcon } from './CashIcon'
export { default as CheckboxCheckedIcon } from './CheckboxCheckedIcon'
export { default as CheckboxUncheckedIcon } from './CheckboxUncheckedIcon'
export { default as CheckIcon } from './CheckIcon'
export { default as CloseIcon } from './CloseIcon'
export { default as HeartIcon } from './HeartIcon'
export { default as HomeIcon } from './HomeIcon'
export { default as LightningIcon } from './LightningIcon'
export { default as SendIcon } from './SendIcon'
// @endindex
